__turbopack_context__.v({
  "animatedLike": "styles-module__uy-Lyq__animatedLike",
  "emptyLikeIcon": "styles-module__uy-Lyq__emptyLikeIcon",
  "filledLikeIcon": "styles-module__uy-Lyq__filledLikeIcon",
  "likeCount": "styles-module__uy-Lyq__likeCount",
  "likeHeartbeat": "styles-module__uy-Lyq__likeHeartbeat",
  "likeIcon": "styles-module__uy-Lyq__likeIcon",
  "whiteLikeButton": "styles-module__uy-Lyq__whiteLikeButton",
});
